import React from "react";
import { Loader2 } from "lucide-react";

export interface LoaderProps {
  size?: number | string;
  className?: string;
  text?: string;
  fullScreen?: boolean;
  "data-testid"?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  size = 28,
  className = "",
  text,
  fullScreen = false,
  "data-testid": testId = "loader",
}) => {
  const content = (
    <div
      data-testid={testId}
      className={`flex flex-col items-center justify-center gap-3 ${
        fullScreen ? "fixed inset-0 z-50 bg-white/80 backdrop-blur-xs" : "py-6"
      } ${className}`}
    >
      <Loader2
        size={typeof size === "number" ? size : 28}
        className="animate-spin text-[#15BBAE]"
        aria-hidden="true"
      />
      {text && <p className="text-xs font-medium text-[#63788E] animate-pulse">{text}</p>}
    </div>
  );

  return content;
};

export default Loader;
